import React from 'react';

import giveMe5 from '@/assets/reply-panel-emojis/give-me-5.png';
import grinningFace from '@/assets/reply-panel-emojis/grinning_squinting_face.gif';
import hushedFace from '@/assets/reply-panel-emojis/hushed_face.gif';
import raisingHands from '@/assets/reply-panel-emojis/raising_hands.gif';
import heart from '@/assets/reply-panel-emojis/sparkling_heart.gif';
import thumbsDown from '@/assets/reply-panel-emojis/thumbs_down.gif';
import thumbsUp from '@/assets/reply-panel-emojis/thumbs_up.gif';

import styles from './Emoji.module.scss';

export enum EmojiCode {
	PRAY = 'pray',
	RAISED_HANDS = 'raised_hands',
	LAUGHING = 'laughing',
	OPEN_MOUTH = 'open_mouth',
	HEART = 'heart',
	THUMBS_UP = 'thumbs_up',
	// THUMBS_DOWN = 'thumbs_down',
}

export interface EmojiProps {
	code: string;
	animated?: boolean;
}

type EmojiCodeMap = {
	[key in EmojiCode]: {
		animated: string;
		static: string;
		ariaLabel: string;
	};
};

// Emoji Unicode ref: https://unicode.org/emoji/charts/full-emoji-list.html
const CODE_MAP: EmojiCodeMap = {
	heart: {
		animated: heart,
		static: '0x2764',
		ariaLabel: 'heart',
	},
	thumbs_up: {
		animated: thumbsUp,
		static: '0x1F44D',
		ariaLabel: 'thumbs up',
	},
	// thumbs_down: {
	// 	animated: thumbsDown,
	// 	static: '0x1F44E',
	// 	ariaLabel: 'thumbs down',
	// },
	pray: {
		animated: giveMe5,
		static: '0x1F64F',
		ariaLabel: 'pray',
	},
	raised_hands: {
		animated: raisingHands,
		static: '0x1F64C',
		ariaLabel: 'raised hands',
	},
	laughing: {
		animated: grinningFace,
		static: '0x1F602',
		ariaLabel: 'laughing',
	},
	open_mouth: {
		animated: hushedFace,
		static: '0x1F62E',
		ariaLabel: 'wonder',
	},
};

export const Emoji = ({ code, animated = false }: EmojiProps) => {
	// In case the code is invalid, don't let the system fail
	const emoji = CODE_MAP[code] ?? CODE_MAP.thumbs_up;

	if (animated) {
		return (
			<img
				className={styles['emoji']}
				src={emoji.animated}
				alt={emoji.ariaLabel}
				aria-label={emoji.ariaLabel}
			/>
		);
	}

	return (
		<span
			className={styles['emoji']}
			role="img"
			aria-label={emoji.ariaLabel}
		>
			{/* Cannot cast string to number code directly */}
			{String.fromCodePoint(emoji.static as unknown as number)}
		</span>
	);
};
